export const headerCompany = ["Azienda", "Indirizzo", "Telefono"];

export const headerSector = [
  "ID Settore",
  "Descrizione",
  "Azienda",
  "Coltura",
  "Lungh. (m)",
  "Largh. (m)",
  "Distanza tra le file di erogaz.(m)",
  "Distanza tra gli erogatori (cm)",
  "Portata nominale dell'erogatore (l/h)",
  "Portata di fertiniez. (l/h)",
  "Lunghezza tubi collettori (m)",
];

/*
export const sector00001 = {
  sectorId: "00001",
  name: "Fragole vicino al lago",
  crop: "fragole",
  length: 15,
  width: 10,
  distanceSupplyRows: 1.25,
  distanceSuppliers: 30,
  nominalFlowRate: 2,
  fertiFlowRate: 120,
  pipeLenght: 150,
};
export const sector00002 = {
  sectorId: "00002",
  name: "Pomodori in serra",
  crop: "pomodori",
  length: 15,
  width: 10,
  distanceSupplyRows: 1.25,
  distanceSuppliers: 30,
  nominalFlowRate: 2,
  fertiFlowRate: 120,
  pipeLenght: 150,
};
export const sector00003 = {
  sectorId: "00003",
  name: "Carciofi muretto",
  crop: "carciofi",
  length: 15,
  width: 10,
  distanceSupplyRows: 1.25,
  distanceSuppliers: 30,
  nominalFlowRate: 2,
  fertiFlowRate: 120,
  pipeLenght: 150,
};
export const sector00004 = {
  sectorId: "00004",
  name: "Lamponi lato Luigino",
  crop: "lamponi",
  length: 15,
  width: 10,
  distanceSupplyRows: 1.25,
  distanceSuppliers: 30,
  nominalFlowRate: 2,
  fertiFlowRate: 120,
  pipeLenght: 150,
};
export const sector00005 = {
  sectorId: "00005",
  name: "Cavoli in campo",
  crop: "cavoli",
  length: 15,
  width: 10,
  distanceSupplyRows: 1.25,
  distanceSuppliers: 30,
  nominalFlowRate: 2,
  fertiFlowRate: 120,
  pipeLenght: 150,
};*/

export const sectors = [
  {
    sectorId: "00001",
    name: "Fragole vicino al lago",
    companyId: "00001",
    cropId: "00001",
    length: 15,
    width: 10,
    distanceSupplyRows: 1.25,
    distanceSuppliers: 30,
    nominalFlowRate: 2,
    fertiFlowRate: 120,
    pipeLength: 150,
  },
  {
    sectorId: "00002",
    name: "Kiwi in serra",
    companyId: "00001",
    cropId: "00002",
    length: 15,
    width: 10,
    distanceSupplyRows: 1.25,
    distanceSuppliers: 30,
    nominalFlowRate: 2,
    fertiFlowRate: 120,
    pipeLength: 150,
  },
  {
    sectorId: "00003",
    name: "Vite muretto",
    companyId: "00002",
    cropId: "00003",
    length: 50,
    width: 100,
    distanceSupplyRows: 2.4,
    distanceSuppliers: 40,
    nominalFlowRate: 1.8,
    fertiFlowRate: 120,
    pipeLength: 20,
  },
  {
    sectorId: "00004",
    name: "Fragole lato Luigino",
    companyId: "00002",
    cropId: "00001",
    length: 15,
    width: 10,
    distanceSupplyRows: 1.25,
    distanceSuppliers: 30,
    nominalFlowRate: 2,
    fertiFlowRate: 120,
    pipeLength: 150,
  },
  {
    sectorId: "00005",
    name: "Kiwi in campo",
    companyId: "00001",
    cropId: "00002",
    length: 15,
    width: 10,
    distanceSupplyRows: 1.25,
    distanceSuppliers: 30,
    nominalFlowRate: 2,
    fertiFlowRate: 120,
    pipeLength: 150,
  },
];

export const companyRowsDefault = [
  {
    companyId: "00001",
    company: "Adriano Pozzar",
    address: {
      street: "Via Pizzacca 10",
      city: "Fiumicello Villa Vicentina",
      province: "Ud",
      country: "It",
    },
    tel: "0431965897",
  },
  {
    companyId: "00002",
    company: "Giulio Alessandris",
    address: {
      street: "Via Isonzo 63A",
      city: "Fiumicello Villa Vicentina",
      province: "Ud",
      country: "It",
    },
    tel: "0431965894",
  },
];
